export var CodeType;
(function (CodeType) {
    CodeType["QR"] = "qr";
    CodeType["BAR"] = "bar";
})(CodeType || (CodeType = {}));
